// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-4-container {
    width: 70%;
    margin: auto;
    margin-bottom: 10rem;
}

.section-4-container>div p {
    margin: 1rem 0;
}

.section-4-container>div>p {
    font-size: var(--font-size4);
}

.section-4-heading {
    font-size: 3rem;
    margin: 0;

    & p:first-child {
        font-weight: lighter;
    }
}

.bold-heading {
    font-weight: bolder;
}

@media screen and (min-width:300px) and (max-width:840px) {
    .section-4-container {
        width: 80%;
        margin-bottom: var(--margin-bottom-mobile);
    }

    .section-4-heading {
        font-size: 1.1rem;
    }

    .section-4-heading~p {
        font-size: 0.625rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Homepage/Section4.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,SAAS;;IAET;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;QACV,0CAA0C;IAC9C;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".section-4-container {\r\n    width: 70%;\r\n    margin: auto;\r\n    margin-bottom: 10rem;\r\n}\r\n\r\n.section-4-container>div p {\r\n    margin: 1rem 0;\r\n}\r\n\r\n.section-4-container>div>p {\r\n    font-size: var(--font-size4);\r\n}\r\n\r\n.section-4-heading {\r\n    font-size: 3rem;\r\n    margin: 0;\r\n\r\n    & p:first-child {\r\n        font-weight: lighter;\r\n    }\r\n}\r\n\r\n.bold-heading {\r\n    font-weight: bolder;\r\n}\r\n\r\n@media screen and (min-width:300px) and (max-width:840px) {\r\n    .section-4-container {\r\n        width: 80%;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .section-4-heading {\r\n        font-size: 1.1rem;\r\n    }\r\n\r\n    .section-4-heading~p {\r\n        font-size: 0.625rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
